export default "__VITE_ASSET__DdGUjIeJ__"